import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FileText, 
  Search, 
  FileCheck, 
  Clock,
  BarChart3,
  TrendingUp
} from 'lucide-react';

const DashboardHome = ({ user, stats, recentActivity, loading }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getActivityIcon = (type) => {
    switch (type) {
      case 'document-analysis':
        return <FileText size={16} />;
      case 'legal-research':
        return <Search size={16} />;
      case 'case-summary':
        return <FileCheck size={16} />;
      default:
        return <FileText size={16} />;
    }
  };

  if (loading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (
    <div>
      {/* Header */}
      <div className="content-header">
        <div className="welcome-section">
          <h2>Welcome back, {user?.name || 'User'}!</h2>
          <p>Here's what's happening with your legal AI tools today.</p>
        </div>
        <div className="user-info">
          <Clock size={16} />
          <span>{new Date().toLocaleDateString('en-US', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}</span>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon blue">
            <FileText size={24} />
          </div>
          <div className="stat-content">
            <h3>{stats.documentsAnalyzed}</h3>
            <p>Documents Analyzed</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon green">
            <Search size={24} />
          </div>
          <div className="stat-content">
            <h3>{stats.researchQueries}</h3>
            <p>Research Queries</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon purple">
            <BarChart3 size={24} />
          </div>
          <div className="stat-content">
            <h3>{stats.casesSummarized}</h3>
            <p>Cases Summarized</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon orange">
            <TrendingUp size={24} />
          </div>
          <div className="stat-content">
            <h3>{stats.hoursEstimate}</h3>
            <p>Hours Saved</p>
          </div>
        </div>
      </div>

      {/* Tool Tabs */}
      <div className="tool-tabs">
        <Link to="/dashboard" className="tool-tab active">Document Analysis</Link>
        <Link to="/dashboard/legal-research" className="tool-tab">Legal Research</Link>
        <Link to="/dashboard/case-summary" className="tool-tab">Case Summary</Link>
        <Link to="/dashboard/contract-review" className="tool-tab">Contract Review</Link>
        <Link to="/dashboard/legal-brief" className="tool-tab">Legal Brief</Link>
        <Link to="/dashboard/compliance" className="tool-tab">Compliance</Link>
        <Link to="/dashboard/precedents" className="tool-tab">Precedents</Link>
        <Link to="/dashboard/document-draft" className="tool-tab">Document Draft</Link>
        <Link to="/dashboard/cost-estimate" className="tool-tab">Cost Estimate</Link>
      </div>

      {/* Document Analysis Tool */}
      <div className="tool-content">
        <div className="tool-header">
          <FileText size={24} />
          <h3>Document Analysis</h3>
        </div>

        <div className="form-group">
          <label className="form-label">Document Name</label>
          <input 
            type="text" 
            className="form-input" 
            placeholder="Enter document name..."
          />
        </div>

        <div className="form-group">
          <label className="form-label">Document Content</label>
          <textarea 
            className="form-textarea" 
            placeholder="Paste your legal document content here..."
          />
        </div>

        <Link to="/dashboard/document-analysis" className="btn btn-primary">
          <FileText size={16} />
          Start Document Analysis
        </Link>
      </div>

      {/* Recent Activity */}
      <div className="recent-activity">
        <h3>Recent Activity</h3>
        {recentActivity.length > 0 ? (
          recentActivity.map((item, index) => (
            <div key={item._id || index} className="activity-item">
              <div className="activity-icon">
                {getActivityIcon(item.type)}
              </div>
              <div className="activity-content">
                <div className="activity-title">{item.title}</div>
                <div className="activity-time">{formatDate(item.createdAt)}</div>
              </div>
            </div>
          ))
        ) : (
          <p style={{ color: '#64748b', textAlign: 'center', padding: '20px' }}>
            No recent activity. Start using the legal AI tools to see your work here.
          </p>
        )}
      </div>
    </div>
  );
};

export default DashboardHome;
